import { useNavigate, useParams } from "react-router";
import AdminNavBar from "../../NavBar/AdminNavBar";
import style from "./UpdateTask.module.css";
import { useEffect, useRef, useState } from "react";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";

export default function UpdateTask() {
    const apiUrl = process.env.REACT_APP_SERVER_URL;
    const [users, setUsers] = useState([]);
    const [loadingUsers] = useState(false);
    const selectRef = useRef(null);
    const { employeeId, taskId } = useParams();
    const token = localStorage.getItem("token");
    const [setError] = useState("");
    const navigate = useNavigate();

    const [tasks, setTasks] = useState({
        title: "",
        description: "",
        finishingDate: "",
        finishingTime: "",
        preferences: "",
        employeeId: [],
        assignedBy: employeeId,
        status: "Pending",
        priority: "Medium",
        category: "",
        attachments: [],
        timeSpent: 0,
    });

    // ✅ Fetch specific task
    useEffect(() => {
        const fetchTask = async () => {
            try {
                const res = await fetch(`${apiUrl}/tasks/${taskId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });

                const data = await res.json();
                if (res.ok && data.task) {
                    const t = data.task;
                    setTasks({
                        title: t.title || "",
                        description: t.description || "",
                        finishingDate: t.finishingDate
                            ? t.finishingDate.split("T")[0]
                            : "",
                        finishingTime: t.finishingTime || "",
                        preferences: t.preferences || "",
                        employeeId: t.employeeId || [],
                        assignedBy: t.assignedBy || employeeId,
                        status: t.status || "Pending",
                        priority: t.priority || "Medium",
                        category: t.category || "",
                        attachments: t.attachments || [],
                        timeSpent: t.timeSpent || 0,
                    });
                } else {
                    console.error("Failed to fetch task:", data.message);
                }
            } catch (err) {
                console.error("Error fetching task:", err);
            }
        };

        fetchTask();
    }, [apiUrl, taskId, token, employeeId]);

    // Fetch all users (for manager & employees)
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await fetch(`${apiUrl}/users`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });
                const data = await res.json();
                if (res.ok) {
                    setUsers(data.users || []);
                } else {
                    setError(data.message || "Failed to fetch users");
                }
            } catch (err) {
                setError(err.message);
            }
        };

        fetchUsers();
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTasks({ ...tasks, [name]: value });
    };

    // Add employee to project
    const handleSelectEmployees = (e) => {
        const selectedId = e.target.value;
        if (selectedId && !tasks.employeeId.includes(selectedId)) {
            setTasks((prev) => ({
                ...prev,
                employeeId: [...prev.employeeId, selectedId],
            }));
        }
        e.target.value = "";
    };

    // Remove last employee
    const handleRemoveLast = () => {
        setTasks((prev) => ({
            ...prev,
            employeeId: prev.employeeId.slice(0, -1),
        }));
    };

    // update the task
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${apiUrl}/tasks/${taskId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(tasks),
            });

            const data = await res.json();
            if (res.ok) {
                alert("✅ Task updated successfully!");
                navigate(`/admin-dashboard/${employeeId}/all-tasks`);
            } else {
                alert("❌ Failed to update task: " + data.message);
            }
        } catch (err) {
            alert("❌ Network error");
        }
    };

    return (
        <>
            <AdminNavBar />
            <div className="container">
                <div className="row mt-lg-2 mb-0 ">

                    {/* BreadCrumb Linkss */}
                    <div className="col-8 col-lg-5 ">
                        <BreadCrumb
                            link={`/admin-dashboard/${employeeId}`}
                            name="Dashboard"
                            icon={true}
                        />
                        <BreadCrumb
                            link={`/admin-dashboard/${employeeId}/all-tasks`}
                            name="All Projects"
                            icon={true}
                        />
                        <BreadCrumb
                            link={`/admin-dashboard/${employeeId}/update-task/${taskId}`}
                            name={`Update Task on ${tasks.title}`}
                        />
                    </div>
                </div>

                <div className={style.createTaskPage}>
                    <div className="container mt-4">
                        <div className={style.pageContainer}>
                            <form
                                onSubmit={handleSubmit}
                                onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                                className="row g-3 p-4 pb-2"
                            >
                                {/* Title & Description */}
                                <div className="col-md-6">
                                    <label htmlFor="title" className="form-label fw-semibold">Title</label>
                                    <input
                                        type="text"
                                        id="title"
                                        name="title"
                                        className="form-control"
                                        placeholder="Task Title"
                                        value={tasks.title}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="description" className="form-label fw-semibold">Description</label>
                                    <input
                                        type="text"
                                        id="description"
                                        name="description"
                                        className="form-control"
                                        placeholder="Task Description"
                                        value={tasks.description}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* Finishing Date & Time */}
                                <div className="col-md-6">
                                    <label htmlFor="finishingDate" className="form-label fw-semibold">Finishing Date</label>
                                    <input
                                        type="date"
                                        id="finishingDate"
                                        name="finishingDate"
                                        className="form-control"
                                        value={tasks.finishingDate}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="finishingTime" className="form-label fw-semibold">Finishing Time</label>
                                    <input
                                        type="time"
                                        id="finishingTime"
                                        name="finishingTime"
                                        className="form-control"
                                        value={tasks.finishingTime}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* Preferences */}
                                <div className="col-12">
                                    <label htmlFor="preferences" className="form-label fw-semibold">Preferences</label>
                                    <input
                                        type="text"
                                        id="preferences"
                                        name="preferences"
                                        className="form-control"
                                        placeholder="Add preferences or notes"
                                        value={tasks.preferences}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* Employee selection */}
                                <div className="col-md-6">
                                    <label className="form-label fw-semibold">Add Employee</label>
                                    <select
                                        ref={selectRef}
                                        className="form-select"
                                        onChange={handleSelectEmployees}
                                        value=""
                                    >
                                        <option value="">Select Employee</option>
                                        {loadingUsers ? (
                                            <option disabled>Loading...</option>
                                        ) : (
                                            users
                                                .filter((u) => u.role?.toLowerCase() === "employee")
                                                .map((u) => (
                                                    <option key={u.employeeId} value={u.employeeId}>
                                                        {u.employeeId} - {u.firstName} {u.lastName}
                                                    </option>
                                                ))
                                        )}
                                    </select>
                                </div>

                                {/* Assigned Employees */}
                                <div className="col-md-6">
                                    <label htmlFor="employeeId" className="form-label fw-semibold">Assigned Employees</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            id="employeeId"
                                            name="employeeId"
                                            className="form-control"
                                            value={tasks.employeeId?.join(", ") || ""}
                                            onChange={(e) =>
                                                setTasks({
                                                    ...tasks,
                                                    employeeId: e.target.value
                                                        .split(",")
                                                        .map((id) => id.trim())
                                                        .filter(Boolean),
                                                })
                                            }
                                            placeholder="Enter employee IDs separated by commas"
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger"
                                            onClick={handleRemoveLast}
                                        >
                                            Clear
                                        </button>
                                    </div>
                                </div>

                                {/* Status, Priority, Category */}
                                <div className="col-md-4">
                                    <label htmlFor="status" className="form-label fw-semibold">Status</label>
                                    <select
                                        id="status"
                                        name="status"
                                        className="form-select"
                                        value={tasks.status}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="Pending">Pending</option>
                                        <option value="In Progress">In Progress</option>
                                        <option value="Completed">Completed</option>
                                        <option value="On Hold">On Hold</option>
                                    </select>
                                </div>

                                <div className="col-md-4">
                                    <label htmlFor="priority" className="form-label fw-semibold">Priority</label>
                                    <select
                                        id="priority"
                                        name="priority"
                                        className="form-select"
                                        value={tasks.priority}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Priority</option>
                                        <option value="Low">Low</option>
                                        <option value="Medium">Medium</option>
                                        <option value="High">High</option>
                                        <option value="Critical">Critical</option>
                                    </select>
                                </div>

                                <div className="col-md-4">
                                    <label htmlFor="category" className="form-label fw-semibold">Category</label>
                                    <input
                                        type="text"
                                        id="category"
                                        name="category"
                                        className="form-control"
                                        placeholder="Category"
                                        value={tasks.category}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* Submit */}
                                <div className="col-12 text-center mt-4 mb-2">
                                    <button type="submit" className="btn btn-primary px-4">
                                        Update Task
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
